import { Component, OnInit, HostListener, Input } from '@angular/core';
import * as d3 from 'd3';
import { max } from 'rxjs/operators';

@Component({
    selector: 'app-weightage-chart',
    templateUrl: './weightage-chart.component.html',
})
export class WeightageChartComponent {
    @Input() GraphData: any;
    leftData: number[];
    rightData: number[];
    type: any;
    data = [];

    constructor() { }
    ngOnChanges() {
        //ngAfterViewInit() {
        if (this.GraphData) {
            this.drawGraph();
        }
    }
    drawGraph() {
        let that = this;
        this.data = this.GraphData.map((d, i) => {
            let TAT = d.TAT == null ? 0 : d.TAT;
            return { 'type': d.CategoryName, 'volume': d.TicketCount, 'turnAroundTime': TAT, 'multiply': (d.TicketCount * (TAT == 0 ? 1 : TAT)) };
        });
        this.data.sort(function (a, b) {
            return b.multiply - a.multiply;
        });
        this.leftData = [];
        this.rightData = [];
        this.type = [];
        this.data.forEach(element => {
            this.leftData.push(element.volume);
            this.rightData.push(element.turnAroundTime);
            this.type.push(element.type);
        });

        const margin = { top: 50, bottom: 0, left: 50, right: 20 };
        let noOfData = this.type.length ? this.type.length : 1;
        let setHeight = 50;
        let chartHeight = setHeight * noOfData;
        if (noOfData < 8) {
            let magicNumber = Math.floor((425 - chartHeight) / noOfData);
            setHeight = setHeight + magicNumber;
            chartHeight = setHeight * noOfData;
        }
        let svgYTransform = 0;
        // if (chartHeight < 425) // align the chart in center
        // {
        //     svgYTransform = (425 - chartHeight) / 2;
        // }
        const rx = 6;
        const ry = 6;
        const gap = 2;
        let elem_wrapper = <HTMLElement>document.getElementsByClassName('identified-oppurtunities__wrapper')[0];
        let elem = <HTMLElement>document.getElementById('identified-oppurtunities-section'); //identified-oppurtunities-section')[0];
        let elemBottom = <HTMLElement>document.getElementById('x-axis__wrapper');
        elem.innerHTML = "";
        elemBottom.innerHTML = "";
        const chart = d3.select("#identified-oppurtunities-section")
            .append("svg")
            .attr("width", "100%")
            .attr('transform', 'translate(0,0)')
            .attr("height", chartHeight)
        var tempElement = chart.append('text').attr('id', 'temp_identified-oppurtunities-section');

        //const margin1 = { top: 0, bottom: 10, left: 20, right: 20 };
        const x_axis_height = 50

        const bottom_svg = d3.select("#x-axis__wrapper")
            .append("svg")
            .attr("width", "100%")
            .attr('transform', 'translate(0,' + (svgYTransform == 0 ? 0 : -20) + ')')
            .attr("height", x_axis_height)

        const width = elem_wrapper.offsetWidth - margin.left - margin.right;
        const height = chartHeight - margin.top - margin.bottom;
        let leftMaxData = d3.max(this.leftData);
        let leftQuotient = Math.floor(leftMaxData / 100);
        let leftTickArray = [];
        leftTickArray.push(0);
        if (leftMaxData == 0) {
            leftMaxData = 10;
        }
        else if (leftMaxData < 100) {
            let quo = Math.floor(leftMaxData / 10);
            if (leftMaxData % 10 != 0) {
                leftMaxData = (quo + 1) * 10;
            }
        }
        else if (leftMaxData % 100 != 0) {
            if (leftMaxData % 100 <= 50) {
                leftQuotient = Math.floor(leftMaxData / 50);
                if (leftMaxData % 50 != 0) {
                    leftQuotient = leftQuotient + 1;
                    leftMaxData = leftQuotient * 50;
                }
            }
            else {
                leftQuotient = leftQuotient + 1;
                leftMaxData = leftQuotient * 100;
            }
        }
        else {
            // Do Nothing
        }
        leftTickArray.push(Math.round(leftMaxData / 2));
        leftTickArray.push(Math.round(leftMaxData));
        var xFrom = d3.scaleLinear()
            .domain([leftMaxData, 0])
            .range([0, width / 2.5])
            .nice();
        const left_axis = d3.axisBottom()
            .scale(xFrom)
            //.ticks(4)
            .tickValues(leftTickArray)
            .tickFormat(d => {
                return (d > 1 || d == 0) ? `${d3.format("~s")(d)}` : d.toFixed(1);
            })
            .tickSizeOuter(0);

        bottom_svg.append('g')
            .attr('transform', `translate(${width / 10 - 7},0)`)
            .call(left_axis)
            .call(d => {
                d.select("path").attr("color", "#E9EBF1")
                //d.selectAll("line").remove();
                d.selectAll("text")
                    .style("text-anchor", "middle")
            })
            .attr("font-family", "Graphik Regular")
            .attr("font-size", "12px")
            .attr("color", "#5A5A5A");

        bottom_svg.append('text')
            .attr('transform', `translate(${width / 3 - 44},50)`)
            .attr('font-family', 'Graphik Medium')
            .attr('font-size', '12px')
            .attr('fill', '#5A5A5A')
            .text('Volume')

        var y = d3.scaleBand()
            .domain(this.type)
            .rangeRound([10, height])
            .paddingInner(0.6);

        xFrom.range([0, width / 2.5]);

        chart.selectAll("rect.left")
            .data(this.data)
            .enter().append('path')
            .attr('class', 'bar-left')
            .attr("d", d => {
                if (d.volume <= 0) {
                    return '';
                }
                else {
                    return `M${width / 2 - gap},${y(d.type) + y.bandwidth() / 2}
                    h${rx - (width / 2.5 - xFrom(d.volume))}
                    a${rx},${ry} 0 0 0 ${-rx},${ry}
                    v 2
                    a${rx},${ry} 0 0 0 ${rx},${ry}
                    h${(width / 2.5 - xFrom(d.volume)) - rx}Z`;
                }
            })
            //         .attr("d", d => `
            //   M${width / 2 - gap},${y(d.type) + y.bandwidth() / 2}
            //   h${d.volume > 0 ? (rx - (width / 2.4 - xFrom(d.volume))) : 0}
            //   a${d.volume > 0 ? rx : 0},${d.volume > 0 ? ry : 0} 0 0 0 ${d.volume > 0 ? -rx : 0},${d.volume > 0 ? ry : 0}
            //   v 2
            //   a${d.volume > 0 ? rx : 0},${d.volume > 0 ? ry : 0} 0 0 0 ${d.volume > 0 ? rx : 0},${d.volume > 0 ? ry : 0}
            //   h${(width / 2.4 - xFrom(d.volume)) - (d.volume > 0 ? rx : 0)}Z
            // `)
            .attr('fill', "#008FFF")
            .append('title')
            .text(d => d.volume);

        chart.selectAll("text.leftvalue")
            .data(this.data)
            .enter().append("text")
            .attr("font-family", "Graphik Regular")
            .attr("font-size", "10px")
            .attr("x", d => (width / 100) + xFrom(d.volume) + 19)
            .attr("y", (d, i) => y(d.type) + (y.bandwidth() / 2) + 10)
            .attr("text-anchor", "end")
            .attr('class', 'leftvalue')
            .attr('color', '#4D4F5C')
            .text(d => that.CleanNumberVolume(d.volume))
        let rightMaxData = d3.max(this.rightData);
        let rightQuotient = Math.floor(rightMaxData / 100);
        let rightTickArray = [];
        //rightTickArray.push(0);
        if (rightMaxData == 0) {
            rightMaxData = 10;
        }
        else if (rightMaxData < 100) {
            let quo = Math.floor(rightMaxData / 10);
            if (rightMaxData % 10 != 0) {
                rightMaxData = (quo + 1) * 10;
            }
        }
        else if (rightMaxData % 100 != 0) {
            if (rightMaxData % 100 <= 50) {
                rightQuotient = Math.floor(rightMaxData / 50);
                if (rightMaxData % 50 != 0) {
                    rightQuotient = rightQuotient + 1;
                    rightMaxData = rightQuotient * 50;
                }
            }
            else {
                rightQuotient = rightQuotient + 1;
                rightMaxData = rightQuotient * 100;
            }
        }
        else {
            // Do Nothing
        }
        rightTickArray.push(Math.round(rightMaxData / 4));
        rightTickArray.push(Math.round(rightMaxData / 2));
        rightTickArray.push(Math.round(rightMaxData));
        var xTo = d3.scaleLinear()
            .domain([0, rightMaxData])
            .range([0, width / 2])
            .nice();
        const right_axis = d3.axisBottom()
            .scale(xTo)
            .ticks(3)
            .tickValues(rightTickArray)
            .tickFormat(d => {
                return (d > 1 || d == 0) ? `${d3.format("~s")(d)}` : d.toFixed(1);
            })
            .tickSizeOuter(0);

        bottom_svg.append('g')
            .attr('transform', `translate(${width / 2},0)`)
            .call(right_axis)
            .call(d => {
                d.select("path").attr("color", "#E9EBF1")
                //d.selectAll("line").remove();
                d.select("text").remove();
                d.selectAll("text")
                    .style("text-anchor", "middle")
            })
            .attr("font-family", "Graphik Regular")
            .attr("font-size", "12px")
            .attr("color", "#5A5A5A");
        bottom_svg
            .selectAll('line')
            .attr('stroke', '#E9EBF1')
        bottom_svg.append('text')
            .attr('transform', `translate(${width / 2 + 20},50)`)
            .attr('font-family', 'Graphik Medium')
            .attr('font-size', '12px')
            .attr('fill', '#5A5A5A')
            //.attr('word-wrap', 'break-word')
            .text('Turnaround Time (Median Hrs)')

        xTo.range([0, width / 2]);

        chart.selectAll("rect.right")
            .data(this.data)
            .enter().append('path')
            .attr('class', 'bar')
            .attr("d", d => {
                if (d.turnAroundTime <= 0) {
                    return '';
                }
                else {
                    return `M${width / 2 + gap},${y(d.type) + y.bandwidth() / 2}
                  h${xTo(d.turnAroundTime) - rx}
                  a${rx},${ry} 1 0 1 ${rx},${ry}
                  v 2
                  a${rx},${ry} 1 0 1 ${-rx},${ry}
                  h${rx - (xTo(d.turnAroundTime))}Z`;
                }
            })
            //     .attr("d", d => `
            //   M${width / 2 + gap},${y(d.type) + y.bandwidth() / 2}
            //   h${xTo(d.turnAroundTime) - (d.turnAroundTime > 0 ? rx : 0)}
            //   a${d.turnAroundTime > 0 ? rx : 0},${d.turnAroundTime > 0 ? ry : 0} 1 0 1 ${d.turnAroundTime > 0 ? rx : 0},${d.turnAroundTime > 0 ? ry : 0}
            //   v 2
            //   a${d.turnAroundTime > 0 ? rx : 0},${d.turnAroundTime > 0 ? ry : 0} 1 0 1 ${d.turnAroundTime > 0 ? -rx : 0},${d.turnAroundTime > 0 ? ry : 0}
            //   h${(d.turnAroundTime > 0 ? rx : 0) - (xTo(d.turnAroundTime))}Z
            // `)
            .attr('fill', "#6808D8")
            .append('title')
            .text(d => d.turnAroundTime);

        chart.selectAll("text.rightvalue")
            .data(this.data)
            .enter().append("text")
            .attr("font-family", "Graphik Regular")
            .attr("font-size", "10px")
            .attr("x", d => {
                let temp = that.CleanNumber(d.turnAroundTime);
                temp = (temp == 0 ? 'NA' : temp);
                tempElement.text(d.turnAroundTime);
                let rightValWidth = tempElement.node().getBBox().width;
                return width / 2 + xTo(d.turnAroundTime) + rightValWidth + (temp == 'NA' ? 5 : -2);
            })
            .attr("y", d => y(d.type) + (y.bandwidth() / 2) + 10)
            .attr("text-anchor", "end")
            .attr('class', 'rightvalue')
            .attr('color', '#4D4F5C')
            .text(d => {
                let temp = that.CleanNumber(d.turnAroundTime);
                return temp == 0 ? 'NA' : temp;
            })

        chart.selectAll("text.type")
            .data(this.data)
            .enter()
            .append("text")
            .attr("font-family", "Graphik Medium")
            .attr("font-size", "12px")
            .attr("x", d => {
                let type = d.type;
                if (type.length > 30) {
                    type = type.substring(0, 30) + '...';
                }
                else {
                    type = d.type;
                }
                tempElement.text(type);
                let yAxisLabelWidth = tempElement.node().getBBox().width;
                return (width / 2) + yAxisLabelWidth / 2;
            })
            .attr("y", d => y(d.type) + (y.bandwidth() / 2) - 6)
            .attr("text-anchor", "end")
            .attr('class', 'type-text')
            .attr('fill', '#4D4F5C')
            .text(d => {
                if (d.type.length > 30) {
                    return d.type.substring(0, 30) + '...';
                }
                else {
                    return d.type;
                }
            })
            .append('title')
            .text(d => d.type);
        tempElement.style('display', 'none');
    }
    CleanNumber(str) {
        //str = str.toFixed(2);
        if (str >= 1)
            str = d3.format("~s")(str);
        else
            str = str;
        if (!this.isNumeric(str)) {
            let lastLetter = str.substring(str.length - 1);
            str = str.substring(0, str.length - 1);
            if (str.indexOf('.'))
                str = parseFloat(str).toFixed(1).toString() + lastLetter;
        }
        return str;
    }
    CleanNumberVolume(str) {
        //str = str.toFixed(2);
        if (str >= 1)
            str = d3.format("~s")(str);
        else
            str = str;
        if (!this.isNumeric(str)) {
            let lastLetter = str.substring(str.length - 1);
            str = str.substring(0, str.length - 1);
            if (str.indexOf('.'))
                str = parseFloat(str).toFixed(2).toString() + lastLetter;
        }
        return str;
    }
    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (this.GraphData) {
            this.drawGraph();
        }
    }
    //     ngOnInit() {
    //         this.drawGraph();
    //     }
}
